import React from "react";
import SelectField from "../../../../components/SelectField";
import styles from "./index.module.scss";
import { EmptyStateProps } from "./types";

const EmptyState: React.FC<EmptyStateProps> = ({
    title,
    label,
    name,
    options,
    value,
    onChange
}) => {
    return (
        <div className={styles.section}>
            <h2>{title}</h2>
            <div className="col-12 col-md-10">
                <SelectField
                    label={label}
                    name={name}
                    options={options}
                    value={value}
                    onChange={onChange}
                    minHeight={55}
                />
            </div>
        </div>
    );
};

export default EmptyState;
